// Calls the Email Automations API as JSON (a form-encoded body drops empty fields, and an empty
// one can mean "clear it"). `api()` does not throw on an error status, so the response is checked
// and the API's own message is the one the coach sees.
export const callAutomationsApi = async (
  api,
  path,
  method,
  payload,
  fallbackMessage
) => {
  const response = await api(path, {
    method,
    ...(payload && {
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    }),
  });
  if (response.ok) return response.json();
  const body = await response.json().catch(() => null);
  const message =
    typeof body?.error === "string" ? body.error : body?.error?.message;
  const error = new Error(message || fallbackMessage);
  error.issues = body?.issues;
  throw error;
};
